module.exports = __webpack_public_path__ + "img/crossmark.3dbd7d8e.svg";